import { render, staticRenderFns } from "./profile-my-booking-request-table.vue?vue&type=template&id=f02124e4&scoped=true&"
import script from "./profile-my-booking-request-table.vue?vue&type=script&lang=ts&"
export * from "./profile-my-booking-request-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02124e4",
  null
  
)

export default component.exports